"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardsListingContainerStyle = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var css = styled_components_1.default.div;
exports.CardsListingContainerStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   .cards-listing {\n      padding: 10px 20px;\n   }\n\n   .pagination-listing {\n      padding: 10px 20px;\n      padding-bottom: 40px;\n   }\n"], ["\n   .cards-listing {\n      padding: 10px 20px;\n   }\n\n   .pagination-listing {\n      padding: 10px 20px;\n      padding-bottom: 40px;\n   }\n"])));
var templateObject_1;
//# sourceMappingURL=CardsListingContainer.style.js.map